var React = require('react');
var PropTypes = require('prop-types');

/**
 * @class StyletronProvider
 * @packagename styletron-react
 * @description Provides a Styletron instance to descendant styled components via context
 * @example
 * const Styletron = require('styletron');
 *
 * function render() {
 *   return React.renderToString(
 *     <StyletronProvider styletron={new Styletron()}>
 *       <App/>
 *     </StyletronProvider>
 *   );
 * }
 * 
 * @property {object} styletron - Styletron instance
 * @property {ReactElement} children - children
 * @extends ReactClass
 */
var StyletronProvider = (function (superclass) {
  function StyletronProvider(props, context) {
    superclass.call(this, props, context);
    this.styletron = props.styletron;
  }

  if ( superclass ) StyletronProvider.__proto__ = superclass;
  StyletronProvider.prototype = Object.create( superclass && superclass.prototype );
  StyletronProvider.prototype.constructor = StyletronProvider;
  StyletronProvider.prototype.getChildContext = function getChildContext () {
    return {styletron: this.styletron};
  };

  StyletronProvider.prototype.render = function render () {
    return React.Children.only(this.props.children);
  };

  return StyletronProvider;
}(React.Component));

StyletronProvider.PropTypes = {
  styletron: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired
};

StyletronProvider.childContextTypes = {
  styletron: PropTypes.object.isRequired
};

module.exports = StyletronProvider;



//////////////////
// WEBPACK FOOTER
// ./node_modules/styletron-react/lib/provider.js
// module id = 34
// module chunks = 0